import { atom } from 'recoil'
import { recoilPersist } from 'recoil-persist'
import dayjs from 'dayjs'

const { persistAtom } = recoilPersist()

export const searchValueState = atom({
  key: 'searchValue',
  default: {
    recordDates: {
      startDate: dayjs().format('YYYY-MM-DD'),
      endDate: dayjs().add(1, 'd').format('YYYY-MM-DD'),
    },
    searchText: '',
    selectOrderList: [],
  },
  effects_UNSTABLE: [persistAtom],
})
